module.exports = __webpack_public_path__ + "img/Shva_talk.9809c0bc.gif";